import React, { FC } from 'react';
import {
    SkeletonLoaderTypeEnum,
} from '~/src/components/skeletons/knowledge-base-banners-skeleton/skeleton/skeleton.types';
import { Skeleton } from '~/src/components/skeletons/knowledge-base-banners-skeleton/skeleton/skeleton';
import {
    KnowledgeBaseSkeletonTypeEnum,
} from '~/src/components/skeletons/knowledge-base-banners-skeleton/knowledge-base-banners-skeleton.types';
import * as Styled from './knowledge-base-banners-skeleton.styles';

interface KnowledgeBaseBannersSkeletonProps {
    type: KnowledgeBaseSkeletonTypeEnum;
}

export const KnowledgeBaseBannersSkeleton: FC<KnowledgeBaseBannersSkeletonProps> = ({ type }) => {
    switch (type) {
        case KnowledgeBaseSkeletonTypeEnum.UPPER_BANNER:
            return (
                <Styled.BannerSkeletonWrapper>
                    <Styled.BannerContentContainer>
                        <Skeleton type={SkeletonLoaderTypeEnum.TEXT} height={44} />
                        <Skeleton type={SkeletonLoaderTypeEnum.TEXT} height={72} marginTop={20} />
                    </Styled.BannerContentContainer>
                    <Skeleton type={SkeletonLoaderTypeEnum.IMAGE} width={300} height={180} />
                </Styled.BannerSkeletonWrapper>
            );
        default:
            return (
                <Styled.BannerSkeletonWrapper>
                    <Styled.BannerContentContainer>
                        <Skeleton type={SkeletonLoaderTypeEnum.TEXT} height={40} />
                        <Skeleton type={SkeletonLoaderTypeEnum.TEXT} height={28} marginTop={16} />
                    </Styled.BannerContentContainer>
                    <Skeleton type={SkeletonLoaderTypeEnum.IMAGE} width={250} height={180} />
                </Styled.BannerSkeletonWrapper>
            );
    }
};
